import { Component, ViewEncapsulation, Input, ViewChildren, QueryList, ElementRef, HostListener } from '@angular/core';
import { trigger, state, style, animate, transition, group } from '@angular/animations';
import { CfaTab } from '../cfa-tab';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cfa-toolbar-tab-container',
    templateUrl: './toolbar-tab-container.html',
    styleUrls: ['../../../styles/styles.scss', './toolbar-tab-container.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('openOverlayState', [
            state('void', style({
                'pointer-events': 'none',
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            transition('void => active', group([
                animate('100ms linear', style({ opacity: 1 })),
                animate('120ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'scale(1)' })),
            ])),
            transition('active => void', animate('100ms 25ms linear', style({ opacity: 0 })))
        ]),
        trigger('slideUpState', [
            state('void', style({
                opacity: 0,
                transform: 'translateY(10px)'
            })),
            transition('void => active', group([
                animate('100ms 20ms linear', style({ opacity: 1 })),
                animate('120ms ease-in', style({ transform: 'none' })),
            ])),
            transition('active => void', group([
                animate('100ms linear', style({ opacity: 0 })),
                animate('120ms ease-out', style({ transform: 'translateY(10px)' })),
            ])),
        ])
    ]
})
// tslint:disable-next-line:component-class-suffix
export class CfaToolbarTabContainer {

    @Input() cfaTabs: CfaTab[] = [];

    @Input() useMaterialTheme = false;

    @ViewChildren('tabEl') tabEls: QueryList<ElementRef>;

    constructor() { }

    private closeExpandedTabs(tab?: CfaTab) {
        this.cfaTabs.forEach(t => {
            if (t !== tab) {
                t.expanded = false;
            }
        });
    }

    clickTab(event: Event, tab: CfaTab, expand?: boolean) {
        if (event.defaultPrevented) {
            return;
        }
        event.preventDefault();
        this.closeExpandedTabs(tab);
        if (expand) {
            tab.expanded = !tab.expanded;
        }
        if (!tab.childTabs || tab.childTabs.length === 0) {
            tab.selected.next();
        }
    }

    getActiveTabName(tab: CfaTab) {
        if (!tab.active) {
            return tab.label;
        } else {
            const ctab = this.getActiveChildTab(tab);
            return ctab ? ctab.label : tab.label;
        }
    }

    getActiveChildTab(tab: CfaTab) {
        return tab.childTabs.find(t => t.active);
    }

    @HostListener('document:click', ['$event'])
    handleDocClick(event: any) {
        if (this.tabEls && this.tabEls.length > 0) {
            this.tabEls.forEach((tab, index) => {
                if (tab && !tab.nativeElement.contains(event.target)) {
                    const cfaTab = this.cfaTabs[index];
                    if (cfaTab) {
                        cfaTab.expanded = false;
                    }
                }
            });
        }
    }
}
